import { useTranslation } from 'react-i18next';

import { useBoundStore } from '@Store/index';
import { BUSINESS_FILE_TYPES } from '@Store/slices/kyb/kyb.types';
import { useEffect, useState } from 'react';

export interface IcontainContent {
  type: keyof typeof BUSINESS_FILE_TYPES;
  title: string;
  texts: string[];
}

export const useVerificationCenterHook = () => {
  const { t } = useTranslation();
  const { kybData } = useBoundStore.getState();
  const [activeStep, setActiveStep] = useState(0);

  const [steps, setSteps] = useState({
    numberOfSteps: kybData.business.missingLlcDocuments.length,
    activeStepName: kybData.business.missingLlcDocuments[activeStep],
  });



  
  useEffect(() => {
    setSteps({
      numberOfSteps: kybData.business.missingLlcDocuments.length,
      activeStepName: kybData.business.missingLlcDocuments[activeStep],
    });
  }, [activeStep, kybData.business.missingLlcDocuments]);
  const title = t(`pages.verificationCenter.documents.${steps.activeStepName}.title`);
  const texts = t(`pages.verificationCenter.documents.${steps.activeStepName}.texts`, {
    returnObjects: true,
  });
  const documents = { title, texts };
  return {
    steps,
    setSteps,
    setActiveStep,
    activeStep,
    documents,
  };
};
